import React, { useState, useEffect, useRef } from 'react';
import styles from './CriterionCard.module.css';

const STATUS_COLOR = { PASS: 'var(--green)', FAIL: 'var(--red)', WARN: 'var(--amber)' };

export default function CriterionCard({ criterion: c, index }) {
  const [open, setOpen] = useState(false);
  const barRef = useRef(null);

  // Animate bar fill on mount
  useEffect(() => {
    if (c.barPct !== null && c.barPct !== undefined && barRef.current) {
      const timer = setTimeout(() => {
        if (barRef.current) {
          barRef.current.style.width = Math.min(Math.abs(c.barPct), 100) + '%';
        }
      }, 400 + index * 80);
      return () => clearTimeout(timer);
    }
  }, [c.barPct, index]);

  const pillClass = {
    PASS: styles.pillPass,
    FAIL: styles.pillFail,
    WARN: styles.pillWarn,
  }[c.status] || '';

  const barClass = {
    PASS: styles.barPass,
    FAIL: styles.barFail,
    WARN: styles.barWarn,
  }[c.status] || '';

  const valClass = {
    PASS: styles.valPass,
    FAIL: styles.valFail,
    WARN: styles.valWarn,
  }[c.status] || '';

  return (
    <div
      className={styles.card}
      style={{ animationDelay: `${index * 0.07}s` }}
    >
      <div
        className={`${styles.header} ${open ? styles.headerOpen : ''}`}
        onClick={() => setOpen(o => !o)}
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && setOpen(o => !o)}
      >
        <div className={styles.num}>0{c.id}</div>

        <div className={styles.info}>
          <div className={styles.name}>{c.name}</div>
          <div className={styles.rule}>{c.rule}</div>
        </div>

        <div className={styles.right}>
          <div className={styles.pillRow}>
            <span className={`${styles.pill} ${pillClass}`}>{c.status}</span>
            {c.displayValue && (
              <span className={`${styles.pillVal} ${valClass}`}>{c.displayValue}</span>
            )}
            <span className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`}>▼</span>
          </div>
          {c.barPct !== null && c.barPct !== undefined && (
            <div className={styles.barRow}>
              <div className={styles.barTrack}>
                <div
                  ref={barRef}
                  className={`${styles.barFill} ${barClass}`}
                  style={{ width: '0%' }}
                />
              </div>
              <span className={`${styles.barVal} ${valClass}`}>{c.displayValue}</span>
            </div>
          )}
        </div>
      </div>

      {open && (
        <div className={styles.body}>
          <div className={styles.detailGrid}>
            {(c.details || []).map((d, i) => {
              const dc = { g: styles.dvGreen, r: styles.dvRed, a: styles.dvAmber }[d.color] || '';
              return (
                <div key={i} className={styles.detailCell}>
                  <div className={styles.detailLabel}>{d.label}</div>
                  <div className={`${styles.detailValue} ${dc}`}>{d.value}</div>
                </div>
              );
            })}
          </div>
          <p className={styles.note}>{c.note}</p>
          {c.citation && (
            <div className={styles.citation}>
              <span className={styles.citationIcon}>📚</span>
              <span className={styles.citationText}>{c.citation}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
